import { instance, errorService } from '@/services/api'
import { projectAPIs } from '@/services/authConstantsV1'
import _ from 'lodash'
import { showNotification } from '@/services/calculate'
import { socketEvents, checkLinkAssetEvents } from '@/services/config'
import { AgGridVue } from 'ag-grid-vue'
import CurrencyRenderer from '@/components/DynamicComponents/Renderers/currencyRenderer'
import dateRenderer from '@/components/DynamicComponents/Renderers/dateRenderer'
import CheckBoxEditor from '@/components/DynamicComponents/Renderers/checkboxRender'
import NumberRender from '@/components/DynamicComponents/Renderers/numberRenderer'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
  },
  props: ['projectId', 'asset', 'isArchive'],
  data: function() {
    return {
      visible: false,
      linkMethod: undefined,
      prevoiusLinkMethod: undefined,
      linkMethods: [
        { id: 1, option: 'Pro-Rata (SF)' },
        { id: 2, option: 'Individual' },
      ],
      loading: false,
      linkAssets: [],
      columDefs: [],
      width: '100%',
      height: '400px',
      allowClear: true,
      closable: true,
      gridOptions: null,
      frameworkComponents: null,
      isChange: true,
      loader: false,
      pinnedBottomRow: [],
      pinnedTopRow: [],
      isUpdate: false,
      linkDescription: this.asset.assetName,
    }
  },
  created() {
    this.$root.$on('message-received', this.messageReceived)
    this.$root.$on('linkUnlinkAsset', this.linkUnlinkAsset)
  },
  beforeMount() {
    this.linkMethod = this.asset.linkMethod
    this.prevoiusLinkMethod = this.asset.linkMethod
    this.loadingConfig()
  },
  beforeDestroy() {
    this.$root.$off('message-received')
    this.$root.$off('linkUnlinkAsset')
  },
  mounted() {
    this.visible = true
  },
  methods: {
    loadingConfig() {
      this.gridOptions = {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        rowSelection: 'multiple',
        tooltipShowDelay: 0,
        defaultColDef: {
          sortable: false,
          suppressMovable: true,
          resizable: true,
          editable: false,
          floatingFilter: false,
          menuTabs: [],
        },
      }
      this.frameworkComponents = {
        costPriceCellRenderer: CurrencyRenderer,
        dateRenderer: dateRenderer,
        checkBoxEditor: CheckBoxEditor,
        numberRender: NumberRender,
      }
      this.columDefs = [
        {
          headerName: 'Asset / Building #',
          headerTooltip: 'Asset / Building #',
          headerClass: 'header-center',
          cellStyle: { textAlign: 'center' },
          field: 'assetNumber',
          pinned: 'left',
          width: 140,
        },
        {
          headerName: 'Analysis Type',
          headerTooltip: 'Analysis Type',
          field: 'analysisType',
          tooltipField: 'analysisType',
          width: 150,
        },
        {
          headerName: 'Structure Profile',
          headerTooltip: 'Structure Profile',
          field: 'structureProfile',
          tooltipField: 'structureProfile',
          width: 180,
        },
        {
          headerName: 'Building Use',
          headerTooltip: 'Building Use',
          field: 'buildingUse',
          tooltipField: 'buildingUse',
          width: 150,
        },
        {
          headerName: 'Description / Asset Name',
          headerTooltip: 'Description / Asset Name',
          field: 'description',
          tooltipField: 'description',
          width: 200,
        },
        {
          headerName: 'SF',
          headerTooltip: 'SF',
          headerClass: 'header-center',
          cellStyle: { textAlign: 'center' },
          cellRenderer: 'numberRender',
          field: 'sf',
          width: 100,
        },
        {
          headerName: 'PIS',
          cellRenderer: 'dateRenderer',
          headerClass: 'header-center',
          cellStyle: { textAlign: 'center' },
          cellRendererParams: { type: 'projectDetails' },
          field: 'pis',
          width: 150,
        },
        {
          headerName: 'Cost Basis',
          field: 'costBasis',
          cellStyle: params => {
            if (params.value === 'Total') {
              return { fontWeight: 'bold', textAlign: 'center' }
            } else {
              return { textAlign: 'center' }
            }
          },
          headerClass: 'header-right',
          width: 150,
          cellRenderer: 'costPriceCellRenderer',
          header: 'Cost Basis',
          pinned: 'right',
        },
        {
          headerName: 'Allocation Cost',
          field: 'allocationCost',
          cellStyle: params => {
            if (params.data.cost_Basis === 'Total') {
              return { fontWeight: 'bold', textAlign: 'center' }
            } else {
              return { textAlign: 'center' }
            }
          },
          headerClass: 'header-right',
          width: 170,
          cellRenderer: 'costPriceCellRenderer',
          headerTooltip: 'Allocation Cost',
          pinned: 'right',
        },
        {
          headerName: 'Link',
          field: 'linkedAssetId',
          width: 70,
          cellRenderer: 'checkBoxEditor',
          headerClass: 'header-center',
          headerTooltip: 'Link',
          cellStyle: { textAlign: 'center' },
          cellRendererParams: {
            masterType: 'projectDetails',
            type: 'projectDetails',
            assetType: 'Link',
          },
          resizable: false,
          pinned: 'right',
          menuTabs: [],
          hide: this.isArchive,
        },
      ]
    },

    getLinkAssets(params) {
      this.loader = true
      instance
        .get(projectAPIs.project.asset.link.list(this.projectId, this.asset.id))
        .then(response => {
          this.pinnedBottomRow = []
          this.pinnedTopRow = []
          const list = _.get(response.data, 'result', [])
            .filter(i => i.analysisTypeId === this.asset.analysisTypeId)
            .sort((x, y) =>
              x.id === this.asset.id ? -1 : y.id === this.asset.id,
            )
          switch (this.linkMethod) {
            case 1:
              this.linkAssets = list.filter(
                i =>
                  i.structureProfileId === this.asset.structureProfileId &&
                  i.id !== this.asset.id,
              )
              this.isChange = false
              break
            case 2:
              this.isChange = list.some(
                i =>
                  i.linkedAssetId === this.asset.id &&
                  i.structureProfileId !== this.asset.structureProfileId,
              )
              this.linkAssets = list.filter(i => i.id !== this.asset.id)
              break
            default:
              this.linkAssets = list.filter(i => i.id !== this.asset.id)
              this.isChange = false
              break
          }
          this.pinnedTopRow.push(list[0])
          this.pinnedBottomRow.push({
            costBasis: 'Total',
            allocationCost: list.reduce(
              (i, y) => i + _.get(y, 'allocationCost', 0),
              0,
            ),
            linkAssetId: undefined,
          })
          this.allowClear = this.linkAssets.every(
            i => i.linkedAssetId !== this.asset.id,
          )
          this.columDefs.map(i => {
            if (i.field === 'linkedAssetId') {
              Object.assign(i.cellRendererParams, {
                isLinked: this.linkMethod,
              })
            }
            return i
          })
          params.api.setColumnDefs(this.columDefs)
          params.api.setRowData(this.linkAssets)
          if (this.asset.analysisTypeId === 2) {
            this.linkMethods = this.linkMethods.filter(i => i.id === 1)
          }
          this.loader = false
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    onChangeLinkMethod() {
      if (this.prevoiusLinkMethod && this.asset.analysisTypeId === 1) {
        const data = this.checkLinkMethod()
        if (data.linkedAssets.length > 0) {
          var that = this
          this.$confirm({
            title: `Are you sure you want to change link method from ${data.previous} to ${data.current}?`,
            content: h => (
              <div style="color:red">
                <p>{data.description}</p>
                <p>Please confirm.</p>
              </div>
            ),
            onOk() {
              that.updateLinkMethod()
            },
            onCancel() {
              that.linkMethod = that.prevoiusLinkMethod
            },
          })
        } else {
          this.updateLinkMethod()
        }
      } else {
        this.updateLinkMethod()
      }
    },

    checkLinkMethod() {
      const currentLinkMethod =
        this.linkMethod === 1 ? 'Pro-Rata (SF)' : 'Individual'
      const previousLinkMethod =
        this.prevoiusLinkMethod === 1 ? 'Pro-Rata (SF)' : 'Individual'
      const linkedAssets = this.linkAssets
        .filter(i => i.linkedAssetId === this.asset.id)
        .map(x => x.description || x.assetNumber)
      let description
      if (this.linkMethod === 1) {
        description = `This action will delete takeoffs from ${linkedAssets.join(
          ', ',
        )} and merge into
      ${this.asset.description || this.asset.assetNumber}.`
      } else if (this.linkMethod === 2) {
        description = `This action will copy ${this.asset.description ||
          this.asset.assetNumber} data into ${linkedAssets.join(', ')}.`
      }

      return {
        current: currentLinkMethod,
        previous: previousLinkMethod,
        description: description,
        linkedAssets: linkedAssets,
      }
    },

    updateLinkMethod() {
      this.loading = true
      this.closable = false
      instance
        .patch(
          projectAPIs.project.asset.link.linkMethod(
            this.projectId,
            this.asset.id,
          ),
          {
            LinkMethod: this.linkMethod ? this.linkMethod : 0,
          },
        )
        .then(response => {
          this.prevoiusLinkMethod = this.linkMethod
          if (this.linkMethod !== 1 && this.linkDescription) {
            this.linkDescription = null
            this.updateLinkDescription()
          }
          this.isUpdate = true
        })
        .catch(err => {
          this.loading = false
          this.closable = true
          errorService(err)
        })
    },

    linkUnlinkAsset(value, id) {
      this.loading = true
      this.closable = false
      let url = projectAPIs.project.asset.link.unlink(
        this.projectId,
        this.asset.id,
        id,
      )
      let request
      if (value) {
        url = projectAPIs.project.asset.link.link(
          this.projectId,
          this.asset.id,
          id,
        )
        request = instance.patch(url, {
          linkMethod: this.linkMethod,
        })
      } else {
        request = instance.patch(url)
      }
      request
        .then(response => {
          this.prevoiusLinkMethod = this.linkMethod
          this.isUpdate = true
        })
        .catch(err => {
          this.loading = false
          this.closable = true
          errorService(err)
        })
    },

    updateLinkDescription() {
      this.loading = true
      instance
        .patch(
          projectAPIs.project.asset.update(
            this.$route.params.id,
            this.asset.id,
          ),
          {
            assetName: this.linkDescription || null,
          },
        )
        .then(response => {
          this.loading = false
          this.isUpdate = true
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    onCancel() {
      this.visible = false
      this.$emit('onCancel', this.isUpdate)
    },

    // socket listen
    messageReceived: function(message) {
      this.$notification.destroy()
      const data = JSON.parse(message.message)
      if (checkLinkAssetEvents(data.EventType)) {
        this.loading = false
        this.closable = true
        this.getLinkAssets(this.gridOptions)
      } else if (data.EventType === socketEvents.error) {
        showNotification('error', 'Error', data.Result)
      }
    },
  },
}
